import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import toast, { Toaster } from "react-hot-toast";
import { useHistory, useLocation, Link } from "react-router-dom";
import {
  getDate,
  searchFilter,
  handleSort,
  detailviewportfolioReviewPath,
  sentdetailviewportfolioReviewPath,
} from "../utils/varialbles";
import http from "../services/reportsPath";
import SearchBar from "material-ui-search-bar";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  table: {
    field: "Resizing",
    title: "Column Width",
    cellStyle: {
      whiteSpace: "nowrap",
      width: "20%",
    },
  },
  tableRow: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  indeterminateColor: {
    color: "#f50057",
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },
  checked: {},
});

export default function PendingportfolioReview() {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [searched, setSearched] = useState("");
  const [orignalRows, setOriginalRows] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [totalRowCount, setTotalRowCount] = useState(0);
  let history = useHistory();
  const [columns, setColumns] = useState([
    {
      headerName: "Customer ID",
      id: "cust_id",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Mobile Number",
      id: "Mobile Number",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "CDT Name",
      id: "Employee",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Name",
      id: "Name",
      show: true,
      minWidth: 100,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Created Date",
      id: "Created Date",
      show: true,
      minWidth: 150,
      format: "date",
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Advise Sent Date",
      id: "Advise sent date",
      show: true,
      minWidth: 200,
      format: "date",
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Status",
      id: "Status",
      show: true,
      minWidth: 200,
      // type: "array",
      // headerAlign: "center",
      // align: "center",
    },
  ]);

  //Update values based on keys for the column Recommended Action
  const statusMap = {
    A: "Advised",
    R: "Request Pending",
    P: "Request Raised",
  };

  const getPaginationURL = (url, newQuery) => {
    const query = newQuery === "" ? newQuery : searched;
    if (query) {
      return `${url}?page=${
        page + 1
      }&rowsPerPage=${rowsPerPage}&search=${query}`;
    } else {
      return `${url}?status=A&page=${page + 1}&rowsPerPage=${rowsPerPage}`;
    }
  };

  const requestSearch = (searchedVal) => {
    let rowsTemp = [...rows];
    setPage(0);
    setOriginalRows(searchFilter(searchedVal, rowsTemp));
  };
  const cancelSearch = () => {
    // getData();
    setSearched("");
    requestSearch(searched);
  };

  useEffect(() => {
    getData();

    localStorage.setItem("adviserowsperpage", rowsPerPage);
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("selectedinvestorfiltersdata");
  }, [page, rowsPerPage]);

  const getData = (newQuery) => {
    const baseURL = "/portfolio_review_list_view";
    toast.loading("Please wait...");
    setOriginalRows([]);
    setRows([]);

    http.get(getPaginationURL(baseURL, newQuery)).then((response) => {
      toast.dismiss();
      if (
        response &&
        response.data &&
        response.data.statusCode === 0 &&
        Array.isArray(response.data.Data)
      ) {
        let tempDta = response.data.Data;

        // setOriginalRows(tempDta.slice().reverse());
        setOriginalRows(tempDta);
        setRows(tempDta);
        setTotalRowCount(response.data.totalRowCount);
      } else {
        setOriginalRows([]);
        setRows([]);
        setTotalRowCount(0);
      }
    });
  };

  let filteredCol = columns.filter((data) => {
    if (data.show) {
      return data;
    }
  });

  const handleChangePage = (event, newPage) => {
    // (newPage);
    setPage(newPage);
  };

  // const handleRequestSort = (e, property, format) => {
  //   let isAsc = orderBy === property && order === "asc";
  //   setOrder(isAsc ? "desc" : "asc");
  //   setOrderBy(property);
  //   let tempRows = [...rows];
  //   let finalRows = handleSort(property, format, tempRows, isAsc);
  //   setRows(finalRows);
  //   setPage(0);
  // };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // takes you to detail view
  const viewProspectDetails = (object) => {
    object.page = page;
    history.push({
      pathname: sentdetailviewportfolioReviewPath,
      state: object,
    });
  };

  return (
    <>
      <Paper className={classes.root}>
        <div className="prospectsearchfilterboth">
          <div className="prospectsearch">
            {/* <SearchBar
              value={searched}
              onChange={(searchVal) => requestSearch(searchVal)}
              onCancelSearch={() => cancelSearch()}
              style={{ height: "unset", padding: 5 }}
            /> */}
          </div>

          <div>
            <TablePagination
              rowsPerPageOptions={[10, 50, 100, 500]}
              component="div"
              count={totalRowCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {filteredCol.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="prospect_table"
                  >
                    {/* <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    >
                    </TableSortLabel> */}
                    {column.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {orignalRows.length !== 0 ? (
                <>
                  {orignalRows.map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index + "a"}
                        className="prospecttable"
                      >
                        {filteredCol.map((column, index) => {
                          const value = row[column.id];

                          return (
                            <TableCell
                              key={index + column.id}
                              align={column.align}
                              onDoubleClick={() => viewProspectDetails(row)}
                            >
                              {column.format === "date"
                                ? getDate(value)
                                : value === ""
                                ? "N/A"
                                : statusMap[value]
                                ? statusMap[value]
                                : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </>
              ) : (
                <TableCell
                  colspan="6"
                  style={{ "text-align": "center", margin: "10px 0px" }}
                >
                  No Records to Show
                </TableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <div>
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 500]}
            component="div"
            count={totalRowCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    </>
  );
}
